export default __webpack_public_path__ + "static/media/R7SR11_R7SR12.d440ae78.png";